<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="400px"
    :innerScroll="false"
    :loading="loading"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px">
     <el-row>
			<el-col :span="24">
				<el-form-item label="包件编码:" prop="packCode">
				  <el-input  v-model.trim="addForm.packCode" @blur="packCodeBlur"  size="small" style="width: 200px"></el-input>
				</el-form-item>
				<el-form-item label="包件名称:" prop="packName">
          <el-tooltip class="item" effect="dark" :content="addForm.packName" placement="top-start" v-if="addForm.packName && addForm.packName.length >= 30">
            <div class="textTips">{{addForm.packName || ''}}</div>
          </el-tooltip>
				  <span v-else>{{addForm.packName}}</span>
				</el-form-item>
			</el-col>
     </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import moment from 'moment'
import axios from '@/utils/axiosInstance'
export default {
  name: 'add',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false
    },

  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    title() {
      return '新增'
    },
  },
  data() {
    return {
      loading: false,
      addForm: {},
      rules: {
        packCode: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false
    },
    packCodeBlur() {
      if(!this.addForm.packCode) {
        this.addForm.packName = ''
        return
      }
      let data = {
        pageSize: 1,
        pageNum: 1,
        reportCode: "searchPackInfo",
        param: {
          packCode: this.addForm.packCode
        },
        queryMatch: [],
        orderList: [],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      }
      axios
        .post(`/ec-pc-api/custom/reports/data/searchPackInfo`, data)
        .then((res) => {
          this.$set(this.addForm,'packName',res.data.list[0].packName)
        })
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return
      this.loading = true
      this.$q.product.withdrawAdd({data: this.addForm})
        .then((res) => {
          if (res.code == 200) {
            this.onCancel()
            this.$message.success('新增成功')
            this.$emit('success')
          }
        })
        .finally(() => {
          this.loading = false;
        });
         
      })
    },
    async init() {
    },
  },
  created() {
  },
}
</script>

<style lang="stylus" scoped>
.textTips {
  cursor: pointer
  height: 40px
  overflow: hidden
  white-space: nowrap;
  text-overflow: ellipsis
}
</style>